<template>
  <div>
    <b-card class="standardpage border-none">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="budgets.icon" class="mr-1"></i>
            <span>{{ budgets.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">

            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Code" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="code" :debounce="budgets.debounce" placeholder="Code"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!code" @click="code = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Name" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="description" :debounce="budgets.debounce"
                      placeholder="Description"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!description"
                        @click="description = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Active?" label-for="isactive" label-cols="12">
                  <treeselect instanceId="isactive" type="number" v-model="isactive" :clearable="true"
                    :options="isactive_options"></treeselect>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="budgets" :icon="budgets.icon" :busy="budgets.busy"
            :toolbarlibrary="budgets.toolbarlibrary" :tools="budgets.tools" :badges="budgets.badges"
            :fields="budgets.fields" :items="budgets.items" :limit="budgets.limit" :downloaded="budgets.downloaded"
            :showpages="true" :offset="budgets.offset" :page="budgets.page" @load="budgets_load" @click="budgets_click"
            @changed="budgets_click('save', $event)" @select="budgets_select">
          </d-table>
        </div>
      </div>

      <div v-show="component">
        <component :is="component" :selection="budgets.selected" :config="cconfig" @discard="budgets_click('discard')"
          @go="budgets_click('go')"></component>
      </div>
      <b-card-footer class="mt-2 ml-1">
        <div class="text-center">
          <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
            <i class="fa fa-cogs mr-2"></i>Setup All
          </b-button>
        </div>
      </b-card-footer>
    </b-card>
  </div>
</template>


<script>
import gql from "graphql-tag";

import Setup_BudgetsEdit from "./Components/Setup_BudgetsEdit";

export default {
  name: "Setup_Budgets",
  components: { Setup_BudgetsEdit },
  watch: {
    async code() {
      await this.budgets_load(0);
    },
    async description() {
      await this.budgets_load(0);
    },
    async isactive() {
      await this.budgets_load(0);
    },
  },
  data() {
    return {
      description: null,
      isactive: true,
      isactive_options: [
        {
          id: true,
          label: "Yes",
        },
        {
          id: false,
          label: "No",
        },
      ],

      budgets: {
        title: "Budgets",
        icon: "fa fa-list",
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        tools: "go,filter,download,add,edit,deleteconfirm",
        toolbarlibrary: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-40px",
          },
          {
            key: "code",
            label: "Code",
            sortable: true,
          },
          {
            key: "description",
            label: "Description",
            sortable: true,
          },
          {
            key: "active",
            label: "Active",
            sortable: true,
          },
          {
            key: "bootstrap",
            label: "Bootstrap",
            sortable: true,
            class: "d-none d-xl-table-cell",
            formatter: (value, key, item) => {
              return "<span class='badge badge-" + value + "' >" + value + "</span>"
            },
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [
          {
            key: "active",
            type: "badge",
            Yes: "success",
            No: "danger",
            formatter: (value, key, item) => {
              if (value == false) {
                return "No";
              } else if (value == true) {
                return "Yes";
              } else {
                return "";
              }
            },
          },
        ],
        items: [],
        selected: [],
        downloaded: [],
        denied: [],
      },
    };
  },
  async mounted() {
    this.accessdenied();
    await this.budgets_load();
  },

  methods: {
    accessdenied() {
      this.budgets.denied = [];
      if (!this.user.permissions.includes("setup_budgets.admin")) {
        this.budgets.denied.push("deleteconfirm");
      }
      if (!this.user.permissions.includes("setup_budgets.admin")) {
        this.budgets.denied.push("add");
        this.budgets.denied.push("save");
      }

    },

    async budgets_load(offset, limit, page) {
      let state = this.budgets;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,
        code: this.code,
        description: this.description,
        isactive: this.isactive,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
              query setup_budgets(
                $limit: Int
                $offset: Int
                $id: String   
                $code: String   
                $description: String  
                $isactive: Boolean            
                $dateformat: String                
              ) {
                setup_budgets(
                  limit: $limit
                  offset: $offset
                  id: $id 
                  code: $code 
                  description: $description 
                  isactive: $isactive
                  dateformat: $dateformat
              
                ) {
                  id
                  code                                
                  description    
                  active
                  bootstrap                         
                  rows
                  updated_at
                  updated_by
                }
              }
            `,
          variables,
        });

        // USE LOCAL VARIABLE        

        state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.setup_budgets
        } else {
          state.items = response.data.setup_budgets;
        }

      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },
    async budgets_click(a, ss) {

      let state = this.budgets;

      switch (a) {
        case "download_view":
          state.downloaded = []
          state.downloaded = state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.budgets_load(0, 0);
          break;

        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
        case "go":
          this.component = null;
          this.budgets_load();
          break;
        case "add":
        case "edit":
          this.component = "Setup_BudgetsEdit";
          break;

        case "save":
          this.saveit(ss);
          break;

        case "delete":
          this.deleteit(ss);
          break;
      }
    },
    async budgets_select(ss, tools) {

      let state = this.budgets;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "download"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async saveit(ss) {

      this.busy = true;

      let variables = { rows: this.cleanit(ss) };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation setup_budgets_save(
                $rows: [setup_budgets_input]             
              ) {
                setup_budgets_save(rows: $rows) {
                    id
                    description
                    
                }
              }
            `,
          variables,
        });
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
    async deleteit(ss) {

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation setup_budgets_delete(
                $rows: [setup_budgets_input]
              ) {
                setup_budgets_delete(rows: $rows) {
                  id
                }
              }
            `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.budgets_load(0);
    },
  },
};
</script>

<style></style>